import { createTheme } from '@mui/material/styles';

const Theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#cc016a",
      contrastText: "#ffffffff"
    },
    secondary: {
      main: "#001729"
    },
    background: {
      default: "#ffffff",
      paper: "#f4f4f5"
    },
    text: {
      primary: '#001729',
      secondary: '#717171ff'
    }
  },
  typography: {
    fontFamily: [
      'Lato'
    ].join(','),
  }
});

export default Theme;